(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1034],{

/***/ 5113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1385);
/* harmony import */ var _styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Checkbox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var title = param.title, view = param.view, checkboxes = param.checkboxes, selected = param.selected, single = param.single, visibility = param.visibility, style = param.style, onChange = param.onChange;
    /** STATES */ var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        var values = Array.isArray(selected) ? selected : [
            selected
        ];
        var validatedValues = checkboxes.filter(function(a) {
            return values.includes(a.value.toString());
        }).map(function(x) {
            return x.value.toString();
        });
        return single ? validatedValues[0] ? [
            validatedValues[0]
        ] : [] : validatedValues;
    }), cb = _$ref[0], setCb = _$ref[1];
    /** HANDLERS */ var handleCheckboxClick = function(v) {
        var newCb = cb.includes(v) ? cb.filter(function(item) {
            return item !== v;
        }) : single ? [
            v
        ] : cb.concat([
            v
        ]);
        setCb(newCb);
        if (onChange) onChange(newCb);
    };
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function() {
        return {
            get: function get() {
                return cb;
            },
            set: function set(v) {
                var values = Array.isArray(v) ? v : [
                    v
                ];
                var validatedValues = checkboxes.filter(function(a) {
                    return values.includes(a.value.toString());
                }).map(function(x) {
                    return x.value.toString();
                });
                setCb(single ? [
                    validatedValues[0]
                ] : validatedValues);
            }
        };
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!selected.length) setCb([]);
        else setCb(Array.isArray(selected) ? single ? [
            selected[0]
        ] : selected : [
            selected
        ]);
    }, [
        selected
    ]);
    /** TEMPLATE */ if (!checkboxes.length || visibility === false) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cb),
            view !== "box" && (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[view]
        ].filter(Boolean).join(" "),
        style: style,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cbTitle),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: [
                    (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cbContent),
                    (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inline)
                ].join(" "),
                children: checkboxes.map(function(value, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: [
                            (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cbChekbox),
                            cb.includes(value.value) && (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active),
                            value.disabled && (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled)
                        ].filter(Boolean).join(" "),
                        onClick: function() {
                            return handleCheckboxClick(value.value);
                        },
                        disabled: value.disabled,
                        children: value.text
                    }, index);
                })
            })
        ]
    });
});
Checkbox.displayName = "Checkbox";
Checkbox.defaultProps = {
    checkboxes: [],
    selected: [],
    visibility: true,
    view: "box"
};
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 8801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4914);
/* harmony import */ var _styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Radio = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var title = param.title, view = param.view, radios = param.radios, selected = param.selected, visibility = param.visibility, style = param.style, onChange = param.onChange;
    /** STATES */ var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(selected), rd = _$ref[0], setRd = _$ref[1];
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return setRd(selected);
    }, [
        selected
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function() {
        return {
            get: function get() {
                return rd;
            },
            set: function set(v) {
                if (!radios.filter(function(r) {
                    return r.value.toString() === v.toString();
                }).length) return;
                setRd(v.toString());
            }
        };
    });
    /** TEMPLATE */ if (!radios.length || !selected.toString().length || visibility === false) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rd),
            view !== "box" && (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[view]
        ].filter(Boolean).join(" "),
        style: style,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rdTitle),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: [
                    (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rdContent),
                    (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inline)
                ].join(" "),
                children: radios.map(function(value, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: [
                            (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rdRadio),
                            rd === value.value && (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active),
                            value.disabled && (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled)
                        ].filter(Boolean).join(" "),
                        onClick: function() {
                            if (rd !== value.value) {
                                setRd(value.value);
                                if (onChange) onChange(value.value);
                            }
                        },
                        disabled: value.disabled,
                        children: value.text
                    }, index);
                })
            })
        ]
    });
});
Radio.displayName = "Radio";
Radio.defaultProps = {
    radios: [],
    selected: "",
    visibility: true,
    view: "box"
};
/* harmony default export */ __webpack_exports__["Z"] = (Radio);


/***/ }),

/***/ 3177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7865);
/* harmony import */ var _styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1__);



var Skelet = function(param) {
    var children = param.children, height = param.height, maxHeight = param.maxHeight, width = param.width, maxWidth = param.maxWidth, style = param.style, className = param.className, invert = param.invert;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: [
            (_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default().skelet),
            className,
            invert && (_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default().invert)
        ].filter(Boolean).join(" "),
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            height: height,
            maxHeight: maxHeight,
            width: width,
            maxWidth: maxWidth
        }, style),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Skelet);


/***/ }),

/***/ 1568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9815);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hooks_useIsMount__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9766);
/* harmony import */ var _context_objects__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1563);
/* harmony import */ var _context_location__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(637);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3725);
/* harmony import */ var _Radio__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8801);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1121);
/* harmony import */ var _Checkbox__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5113);
/* harmony import */ var _Select__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(360);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2077);
/* harmony import */ var _styles_modules_objects_ObjectsFilterMobile_module_scss__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(9292);
/* harmony import */ var _styles_modules_objects_ObjectsFilterMobile_module_scss__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_objects_ObjectsFilterMobile_module_scss__WEBPACK_IMPORTED_MODULE_20__);





















var Modal = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 2280).then(__webpack_require__.bind(__webpack_require__, 2280));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2280)
            ];
        }
    }
});
var isAnyFilters = function(s) {
    var arrFilters = [
        "priceFrom",
        "priceTo",
        "rooms",
        "studio",
        "squareFrom",
        "squareTo",
        "mikroraion",
        "noCommission",
        "exclusive",
        "squareAreaFrom",
        "squareAreaTo",
        "commercialType",
        "squareLivingFrom",
        "squareLivingTo",
        "squareKitchenFrom",
        "squareKitchenTo",
        "floorFrom",
        "floorTo",
        "floorsFrom",
        "floorsTo",
        "ceiling",
        "balcony",
        "renovation",
        "bathroom",
        "buildingType",
        "stock",
        "lotType",
        "subCategory",
        "entrance",
        "commercialBuildingType"
    ];
    var filtersTotal = 0;
    for(var i = 0; i < arrFilters.length; i++)if (s[arrFilters[i]] && (s[arrFilters[i]].length || s[arrFilters[i]] > 0)) filtersTotal++;
    return filtersTotal > 0;
};
var ObjectsFilterMobile = function(param) {
    var isMap = param.isMap;
    /** STATES */ var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var isMount = (0,_hooks_useIsMount__WEBPACK_IMPORTED_MODULE_6__/* .useIsMount */ .z)();
    var locationState = (0,_context_location__WEBPACK_IMPORTED_MODULE_8__/* .useLocationState */ .KJ)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_context_objects__WEBPACK_IMPORTED_MODULE_7__/* .useObjectsProvider */ .v8)(), 2), objectsState = ref[0], setObjectsState = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), foundCount = ref1[0], setFoundCount = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.type), type = ref3[0], setType = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.category), category = ref4[0], setCategory = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.priceFrom), priceFrom = ref5[0], setPriceFrom = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.priceTo), priceTo = ref6[0], setPriceTo = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.noCommission), noCommission = ref7[0], setNoCommission = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.exclusive), exclusive = ref8[0], setExclusive = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.mikroraion), district = ref9[0], setDistrict = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.studio), studio = ref10[0], setStudio = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.rooms), rooms = ref11[0], setRooms = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.squareFrom), squareFrom = ref12[0], setSquareFrom = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.squareTo), squareTo = ref13[0], setSquareTo = ref13[1];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.squareAreaFrom), squareAreaFrom = ref14[0], setSquareAreaFrom = ref14[1];
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.squareAreaTo), squareAreaTo = ref15[0], setSquareAreaTo = ref15[1];
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.commercialType), commercialType = ref16[0], setCommercialType = ref16[1];
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.squareLivingFrom), squareLivingFrom = ref17[0], setSquareLivingFrom = ref17[1];
    var ref18 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.squareLivingTo), squareLivingTo = ref18[0], setSquareLivingTo = ref18[1];
    var ref19 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.squareKitchenFrom), squareKitchenFrom = ref19[0], setSquareKitchenFrom = ref19[1];
    var ref20 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.squareKitchenTo), squareKitchenTo = ref20[0], setSquareKitchenTo = ref20[1];
    var ref21 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.balcony), balcony = ref21[0], setBalcony = ref21[1];
    var ref22 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.ceiling), ceiling = ref22[0], setCeiling = ref22[1];
    var ref23 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.floorFrom), floorFrom = ref23[0], setFloorFrom = ref23[1];
    var ref24 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.floorTo), floorTo = ref24[0], setFloorTo = ref24[1];
    var ref25 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.floorsFrom), floorsFrom = ref25[0], setFloorsFrom = ref25[1];
    var ref26 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.floorsTo), floorsTo = ref26[0], setFloorsTo = ref26[1];
    var ref27 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.renovation), renovation = ref27[0], setRenovation = ref27[1];
    var ref28 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.buildingType), buildingType = ref28[0], setBuildingType = ref28[1];
    var ref29 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.bathroom), bathroom = ref29[0], setBathroom = ref29[1];
    var ref30 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.stock), stock = ref30[0], setStock = ref30[1];
    var ref31 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.lotType), lotType = ref31[0], setLotType = ref31[1];
    var ref32 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.subCategory), subCategory = ref32[0], setSubCategory = ref32[1];
    var ref33 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.entrance), entrance = ref33[0], setEntrance = ref33[1];
    var ref34 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(objectsState.filter.commercialBuildingType), commercialBuildingType = ref34[0], setCommercialBuildingType = ref34[1];
    /** FUNCTIONS */ var handleSearchClick = function() {
        var newFilterSearch = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, objectsState.filter);
        newFilterSearch.type = type;
        newFilterSearch.category = category;
        newFilterSearch.priceFrom = priceFrom;
        newFilterSearch.priceTo = priceTo;
        newFilterSearch.studio = [
            "квартира"
        ].includes(category) ? studio : 0;
        newFilterSearch.rooms = [
            "квартира"
        ].includes(category) ? rooms : [];
        newFilterSearch.squareFrom = [
            "квартира",
            "комната",
            "дом"
        ].includes(category) ? squareFrom : "";
        newFilterSearch.squareTo = [
            "квартира",
            "комната",
            "дом"
        ].includes(category) ? squareTo : "";
        newFilterSearch.squareAreaFrom = [
            "дом",
            "участок"
        ].includes(category) ? squareAreaFrom : "";
        newFilterSearch.squareAreaTo = [
            "дом",
            "участок"
        ].includes(category) ? squareAreaTo : "";
        newFilterSearch.commercialType = [
            "коммерция"
        ].includes(category) ? commercialType : [];
        newFilterSearch.mikroraion = district;
        newFilterSearch.noCommission = noCommission;
        newFilterSearch.exclusive = exclusive;
        newFilterSearch.squareLivingFrom = [
            "квартира",
            "комната",
            "дом"
        ].includes(category) ? squareLivingFrom : "";
        newFilterSearch.squareLivingTo = [
            "квартира",
            "комната",
            "дом"
        ].includes(category) ? squareLivingTo : "";
        newFilterSearch.squareKitchenFrom = [
            "квартира",
            "дом"
        ].includes(category) ? squareKitchenFrom : "";
        newFilterSearch.squareKitchenTo = [
            "квартира",
            "дом"
        ].includes(category) ? squareKitchenTo : "";
        newFilterSearch.floorFrom = [
            "квартира",
            "комната",
            "коммерция"
        ].includes(category) ? floorFrom : "";
        newFilterSearch.floorTo = [
            "квартира",
            "комната",
            "коммерция"
        ].includes(category) ? floorTo : "";
        newFilterSearch.floorsFrom = [
            "квартира",
            "комната",
            "дом",
            "коммерция"
        ].includes(category) ? floorsFrom : "";
        newFilterSearch.floorsTo = [
            "квартира",
            "комната",
            "дом",
            "коммерция"
        ].includes(category) ? floorsTo : "";
        newFilterSearch.ceiling = [
            "квартира",
            "комната",
            "дом",
            "коммерция"
        ].includes(category) ? ceiling : "";
        newFilterSearch.balcony = [
            "квартира",
            "комната"
        ].includes(category) ? balcony : [];
        newFilterSearch.renovation = [
            "квартира",
            "комната",
            "дом",
            "коммерция"
        ].includes(category) ? renovation : [];
        newFilterSearch.bathroom = [
            "квартира",
            "комната"
        ].includes(category) ? bathroom : [];
        newFilterSearch.buildingType = [
            "квартира",
            "комната",
            "дом"
        ].includes(category) ? buildingType : [];
        newFilterSearch.stock = [
            "квартира",
            "комната"
        ].includes(category) ? stock : [];
        newFilterSearch.lotType = [
            "дом",
            "участок"
        ].includes(category) ? lotType : [];
        newFilterSearch.subCategory = [
            "дом"
        ].includes(category) ? subCategory : [];
        newFilterSearch.entrance = [
            "коммерция"
        ].includes(category) ? entrance : [];
        newFilterSearch.commercialBuildingType = [
            "коммерция"
        ].includes(category) ? commercialBuildingType : [];
        newFilterSearch.ads = [];
        setObjectsState({
            type: "SET_PAGINATION",
            payload: {}
        });
        setObjectsState({
            type: "SET_FILTER",
            payload: newFilterSearch
        });
        setObjectsState({
            type: "SET_STATE",
            payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, objectsState.state), {
                isFiltersMobileVisible: false,
                isMapCatalogVisible: false
            })
        });
        if (isMap) router.replace("/".concat(router.query.region, "/objects/map").concat((0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .JSONToQuery */ .vp)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, newFilterSearch, objectsState.map))));
    };
    var handleResetClick = function() {
        setPriceFrom("");
        setPriceTo("");
        setNoCommission(0);
        setExclusive(0);
        setDistrict([]);
        setStudio(0);
        setRooms([]);
        setSquareFrom("");
        setSquareTo("");
        setSquareAreaFrom("");
        setSquareAreaTo("");
        setCommercialType([]);
        setSquareLivingFrom("");
        setSquareLivingTo("");
        setSquareKitchenFrom("");
        setSquareKitchenTo("");
        setBalcony([]);
        setCeiling("");
        setFloorFrom("");
        setFloorTo("");
        setFloorsFrom("");
        setFloorsTo("");
        setRenovation([]);
        setBuildingType([]);
        setBathroom([]);
        setStock([]);
        setLotType([]);
        setSubCategory([]);
        setEntrance([]);
        setCommercialBuildingType([]);
        setObjectsState({
            type: "SET_PAGINATION",
            payload: {}
        });
        setObjectsState({
            type: "SET_FILTER",
            payload: {
                type: type,
                category: category
            }
        });
        setObjectsState({
            type: "SET_STATE",
            payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, objectsState.state), {
                isFiltersMobileVisible: false,
                isMapCatalogVisible: false
            })
        });
        if (isMap) router.replace("/".concat(router.query.region, "/objects/map"));
    };
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (isMount || isMap) return;
        var newLink = [
            "/",
            router.query.region,
            "/objects"
        ].join("");
        switch(objectsState.filter.type){
            default:
            case "продажа":
                newLink += "/buy";
                break;
            case "аренда":
                newLink += "/rent";
                break;
        }
        switch(objectsState.filter.category){
            default:
            case "квартира":
                newLink += "/flats";
                break;
            case "комната":
                newLink += "/rooms";
                break;
            case "дом":
                newLink += "/houses";
                break;
            case "участок":
                newLink += "/sites";
                break;
            case "коммерция":
                newLink += "/commercial";
                break;
        }
        if (objectsState.filter.category === "квартира") {
            if (objectsState.filter.rooms.length === 0 && objectsState.filter.studio) newLink += "/studio";
            if (objectsState.filter.rooms.length === 1 && !objectsState.filter.studio) newLink += "/".concat(objectsState.filter.rooms[0], "k");
        }
        router.replace("".concat(newLink).concat((0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .JSONToQuery */ .vp)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, objectsState.filter, objectsState.pagination, objectsState.sorting), [
            "type",
            "category",
            "length",
            objectsState.filter.studio && !objectsState.filter.rooms.length && "studio",
            !objectsState.filter.studio && objectsState.filter.rooms.length === 1 && "rooms"
        ], [
            "page=1",
            "sort=last-update.date"
        ])));
    }, [
        objectsState.filter,
        objectsState.pagination
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!locationState.isLoaded) return;
        var controller = new AbortController();
        var signal = controller.signal;
        var fetchData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response;
                return _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setIsLoading(true);
                            _ctx.next = 3;
                            return (0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .sleep */ ._v)(300);
                        case 3:
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return axios__WEBPACK_IMPORTED_MODULE_3___default().post("https://baza.estate/api/v2" + "/objects", {
                                type: type,
                                category: category,
                                priceFrom: priceFrom,
                                priceTo: priceTo,
                                studio: [
                                    "квартира"
                                ].includes(category) ? studio : 0,
                                rooms: [
                                    "квартира"
                                ].includes(category) ? rooms : [],
                                squareFrom: [
                                    "квартира",
                                    "комната",
                                    "дом"
                                ].includes(category) ? squareFrom : "",
                                squareTo: [
                                    "квартира",
                                    "комната",
                                    "дом"
                                ].includes(category) ? squareTo : "",
                                squareAreaFrom: [
                                    "дом",
                                    "участок"
                                ].includes(category) ? squareAreaFrom : "",
                                squareAreaTo: [
                                    "дом",
                                    "участок"
                                ].includes(category) ? squareAreaTo : "",
                                commercialType: [
                                    "коммерция"
                                ].includes(category) ? commercialType : [],
                                mikroraion: district,
                                noCommission: noCommission,
                                exclusive: exclusive,
                                squareLivingFrom: [
                                    "квартира",
                                    "комната",
                                    "дом"
                                ].includes(category) ? squareLivingFrom : "",
                                squareLivingTo: [
                                    "квартира",
                                    "комната",
                                    "дом"
                                ].includes(category) ? squareLivingTo : "",
                                squareKitchenFrom: [
                                    "квартира",
                                    "дом"
                                ].includes(category) ? squareKitchenFrom : "",
                                squareKitchenTo: [
                                    "квартира",
                                    "дом"
                                ].includes(category) ? squareKitchenTo : "",
                                floorFrom: [
                                    "квартира",
                                    "комната",
                                    "коммерция"
                                ].includes(category) ? floorFrom : "",
                                floorTo: [
                                    "квартира",
                                    "комната",
                                    "коммерция"
                                ].includes(category) ? floorTo : "",
                                floorsFrom: [
                                    "квартира",
                                    "комната",
                                    "дом",
                                    "коммерция"
                                ].includes(category) ? floorsFrom : "",
                                floorsTo: [
                                    "квартира",
                                    "комната",
                                    "дом",
                                    "коммерция"
                                ].includes(category) ? floorsTo : "",
                                ceiling: [
                                    "квартира",
                                    "комната",
                                    "дом",
                                    "коммерция"
                                ].includes(category) ? ceiling : "",
                                balcony: [
                                    "квартира",
                                    "комната"
                                ].includes(category) ? balcony : [],
                                renovation: [
                                    "квартира",
                                    "комната",
                                    "дом",
                                    "коммерция"
                                ].includes(category) ? renovation : [],
                                bathroom: [
                                    "квартира",
                                    "комната"
                                ].includes(category) ? bathroom : [],
                                buildingType: [
                                    "квартира",
                                    "комната",
                                    "дом"
                                ].includes(category) ? buildingType : [],
                                stock: [
                                    "квартира",
                                    "комната"
                                ].includes(category) ? stock : [],
                                lotType: [
                                    "дом",
                                    "участок"
                                ].includes(category) ? lotType : [],
                                subCategory: [
                                    "дом"
                                ].includes(category) ? subCategory : [],
                                entrance: [
                                    "коммерция"
                                ].includes(category) ? entrance : [],
                                commercialBuildingType: [
                                    "коммерция"
                                ].includes(category) ? commercialBuildingType : [],
                                location: locationState.region,
                                stat: 1
                            }, {
                                signal: signal
                            });
                        case 6:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 9:
                            setFoundCount(response.data.data.count);
                            setIsLoading(false);
                            _ctx.next = 15;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](3);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        13
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            return controller.abort();
        };
    }, [
        locationState,
        type,
        category,
        priceFrom,
        priceTo,
        noCommission,
        exclusive,
        district,
        studio,
        rooms,
        squareFrom,
        squareTo,
        squareAreaFrom,
        squareAreaTo,
        commercialType,
        squareLivingFrom,
        squareLivingTo,
        squareKitchenFrom,
        squareKitchenTo,
        balcony,
        ceiling,
        floorFrom,
        floorTo,
        floorsFrom,
        floorsTo,
        renovation,
        buildingType,
        bathroom,
        stock,
        lotType,
        subCategory,
        entrance,
        commercialBuildingType
    ]);
    /** TEMPLATE */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Modal, {
        title: "Фильтры",
        visibility: objectsState.state.isFiltersMobileVisible,
        onClose: function() {
            return setObjectsState({
                type: "SET_STATE",
                payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, objectsState.state), {
                    isFiltersMobileVisible: false
                })
            });
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Radio__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                title: "Тип сделки",
                radios: [
                    {
                        text: "Купить",
                        value: "продажа"
                    },
                    {
                        text: "Снять",
                        value: "аренда",
                        disabled: category === "участок"
                    }
                ],
                selected: type,
                onChange: function(v) {
                    return setType(v);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Radio__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                title: "Категория объекта",
                radios: [
                    {
                        text: "Квартира",
                        value: "квартира"
                    },
                    {
                        text: "Комната",
                        value: "комната"
                    },
                    {
                        text: "Дом",
                        value: "дом"
                    },
                    {
                        text: "Участок",
                        value: "участок",
                        disabled: type === "аренда"
                    },
                    {
                        text: "Коммерция",
                        value: "коммерция"
                    }
                ],
                selected: category,
                onChange: function(v) {
                    return setCategory(v);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                title: "Стоимость",
                inputs: [
                    {
                        placeholder: "Цена от",
                        mask: "money",
                        value: priceFrom,
                        max: 99999999
                    },
                    {
                        placeholder: "Цена до",
                        mask: "money",
                        value: priceTo,
                        max: 99999999
                    }
                ],
                onChange: function(v) {
                    setPriceFrom(v[0]);
                    setPriceTo(v[1]);
                },
                suffix: "₽"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                title: "Количество комнат",
                checkboxes: [
                    {
                        text: "Студия",
                        value: "студия"
                    },
                    {
                        text: "1К",
                        value: "1"
                    },
                    {
                        text: "2К",
                        value: "2"
                    },
                    {
                        text: "3К",
                        value: "3"
                    },
                    {
                        text: "4К+",
                        value: "4"
                    }
                ],
                visibility: [
                    "квартира"
                ].includes(category),
                selected: studio ? [
                    "студия"
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(rooms)) : rooms,
                onChange: function(v) {
                    if (v.includes("студия")) setStudio(1);
                    else setStudio(0);
                    setRooms(v.filter(function(x) {
                        return x !== "студия";
                    }));
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                title: "Общая площадь",
                inputs: [
                    {
                        placeholder: "Площадь от",
                        mask: "number",
                        value: squareFrom,
                        max: 999999
                    },
                    {
                        placeholder: "Площадь до",
                        mask: "number",
                        value: squareTo,
                        max: 999999
                    }
                ],
                visibility: [
                    "квартира",
                    "комната",
                    "дом"
                ].includes(category),
                suffix: "м\xb2",
                onChange: function(v) {
                    setSquareFrom(v[0]);
                    setSquareTo(v[1]);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                title: "Площадь участка",
                inputs: [
                    {
                        placeholder: "Площадь от",
                        mask: "number",
                        value: squareAreaFrom,
                        max: 999999
                    },
                    {
                        placeholder: "Площадь до",
                        mask: "number",
                        value: squareAreaTo,
                        max: 999999
                    }
                ],
                visibility: [
                    "дом",
                    "участок"
                ].includes(category),
                suffix: "сот",
                onChange: function(v) {
                    setSquareAreaFrom(v[0]);
                    setSquareAreaTo(v[1]);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                title: "Назначение объекта",
                options: [
                    {
                        type: "option",
                        text: "Автосервис",
                        value: "автосервис"
                    },
                    {
                        type: "option",
                        text: "Гостиница",
                        value: "гостиница"
                    },
                    {
                        type: "option",
                        text: "Готовый бизнес",
                        value: "готовый бизнес"
                    },
                    {
                        type: "option",
                        text: "Коммерческая земля",
                        value: "коммерческая земля"
                    },
                    {
                        type: "option",
                        text: "Общепит",
                        value: "общепит"
                    },
                    {
                        type: "option",
                        text: "Офисное помещение",
                        value: "офисное помещение"
                    },
                    {
                        type: "option",
                        text: "ПСН",
                        value: "псн"
                    },
                    {
                        type: "option",
                        text: "Производственное помещение",
                        value: "производственное помещение"
                    },
                    {
                        type: "option",
                        text: "Склад",
                        value: "склад"
                    },
                    {
                        type: "option",
                        text: "Торговое помещение",
                        value: "торговое помещение"
                    }
                ],
                selected: commercialType,
                visibility: [
                    "коммерция"
                ].includes(category),
                multiple: true,
                onChange: function(v) {
                    setCommercialType(v);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                title: "Акции",
                checkboxes: [
                    {
                        text: "Без комиссии",
                        value: "Без комиссии"
                    },
                    {
                        text: "Только у Нас",
                        value: "Только у Нас"
                    }
                ],
                selected: [
                    noCommission && "Без комиссии",
                    exclusive && "Только у Нас"
                ].filter(function(x) {
                    return x;
                }),
                onChange: function(v) {
                    setNoCommission(Number(v.includes("Без комиссии")));
                    setExclusive(Number(v.includes("Только у Нас")));
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                style: {
                    borderTop: "1px dashed #e8ebef",
                    margin: "18px -12px "
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                title: "Жилая площадь",
                inputs: [
                    {
                        placeholder: "Площадь от",
                        mask: "number",
                        value: squareLivingFrom,
                        max: 999999
                    },
                    {
                        placeholder: "Площадь до",
                        mask: "number",
                        value: squareLivingTo,
                        max: 999999
                    }
                ],
                visibility: [
                    "квартира",
                    "комната",
                    "дом"
                ].includes(category),
                suffix: "м\xb2",
                onChange: function(v) {
                    setSquareLivingFrom(v[0]);
                    setSquareLivingTo(v[1]);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                title: "Кухонная площадь",
                inputs: [
                    {
                        placeholder: "Площадь от",
                        mask: "number",
                        value: squareKitchenFrom,
                        max: 999999
                    },
                    {
                        placeholder: "Площадь до",
                        mask: "number",
                        value: squareKitchenTo,
                        max: 999999
                    }
                ],
                visibility: [
                    "квартира",
                    "дом"
                ].includes(category),
                suffix: "м\xb2",
                onChange: function(v) {
                    setSquareKitchenFrom(v[0]);
                    setSquareKitchenTo(v[1]);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                title: "Балкон",
                checkboxes: [
                    {
                        text: "Балкон",
                        value: "балкон"
                    },
                    {
                        text: "Лоджия",
                        value: "лоджия"
                    }
                ],
                selected: balcony,
                visibility: [
                    "квартира",
                    "комната"
                ].includes(category),
                onChange: function(v) {
                    setBalcony(v);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                title: "Высота потолков",
                checkboxes: [
                    {
                        text: "от 2.5м",
                        value: "2.5"
                    },
                    {
                        text: "от 2.7м",
                        value: "2.7"
                    },
                    {
                        text: "от 3м",
                        value: "3"
                    },
                    {
                        text: "от 4м",
                        value: "4"
                    }
                ],
                single: true,
                selected: ceiling,
                visibility: [
                    "квартира",
                    "комната",
                    "дом",
                    "коммерция"
                ].includes(category),
                onChange: function(v) {
                    setCeiling(v[0]);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                title: "Этаж",
                inputs: [
                    {
                        placeholder: "Этаж от",
                        mask: "number",
                        value: floorFrom,
                        max: 99
                    },
                    {
                        placeholder: "Этаж до",
                        mask: "number",
                        value: floorTo,
                        max: 99
                    }
                ],
                visibility: [
                    "квартира",
                    "комната",
                    "коммерция"
                ].includes(category),
                suffix: "эт",
                onChange: function(v) {
                    setFloorFrom(v[0]);
                    setFloorTo(v[1]);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                title: "Этажей",
                inputs: [
                    {
                        placeholder: "Этажей от",
                        mask: "number",
                        value: floorsFrom,
                        max: 999999
                    },
                    {
                        placeholder: "Этажей до",
                        mask: "number",
                        value: floorsTo,
                        max: 999999
                    }
                ],
                visibility: [
                    "квартира",
                    "комната",
                    "дом",
                    "коммерция"
                ].includes(category),
                suffix: "эт",
                onChange: function(v) {
                    setFloorsFrom(v[0]);
                    setFloorsTo(v[1]);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                title: "Ремонт",
                options: [
                    {
                        type: "option",
                        text: "Дизайнерский",
                        value: "дизайнерский"
                    },
                    {
                        type: "option",
                        text: "Евроремонт",
                        value: "евро"
                    },
                    {
                        type: "option",
                        text: "Требует ремонта",
                        value: "требует ремонта"
                    },
                    {
                        type: "option",
                        text: "Хороший",
                        value: "хороший"
                    },
                    {
                        type: "option",
                        text: "Частичный ремонт",
                        value: "частичный ремонт"
                    },
                    {
                        type: "option",
                        text: "Черновая отделка",
                        value: "черновая отделка"
                    }
                ],
                selected: renovation,
                visibility: [
                    "квартира",
                    "комната",
                    "дом",
                    "коммерция"
                ].includes(category),
                multiple: true,
                onChange: function(v) {
                    setRenovation(v);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                title: "Санузел",
                checkboxes: [
                    {
                        text: "Совмещенный",
                        value: "совмещенный"
                    },
                    {
                        text: "Раздельный",
                        value: "раздельный"
                    },
                    {
                        text: "Два и более",
                        value: "два и более"
                    }
                ],
                selected: bathroom,
                visibility: [
                    "квартира",
                    "комната"
                ].includes(category),
                onChange: function(v) {
                    setBathroom(v);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                title: "Материал стен дома",
                options: [
                    {
                        type: "option",
                        text: "Блочный",
                        value: "блочный"
                    },
                    {
                        type: "option",
                        text: "Кирпично-монолитный",
                        value: "кирпично-монолитный"
                    },
                    {
                        type: "option",
                        text: "Кирпичный",
                        value: "кирпичный"
                    },
                    {
                        type: "option",
                        text: "Монолит",
                        value: "монолит"
                    },
                    {
                        type: "option",
                        text: "Панельный",
                        value: "панельный"
                    },
                    {
                        type: "option",
                        text: "Деревянный",
                        value: "деревянный"
                    }
                ],
                selected: buildingType,
                visibility: [
                    "квартира",
                    "комната",
                    "дом"
                ].includes(category),
                multiple: true,
                onChange: function(v) {
                    setBuildingType(v);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                title: "Фонд здания",
                options: [
                    {
                        type: "option",
                        text: "Коттедж",
                        value: "коттедж"
                    },
                    {
                        type: "option",
                        text: "Новостройка",
                        value: "новостройка"
                    },
                    {
                        type: "option",
                        text: "Современный",
                        value: "современный"
                    },
                    {
                        type: "option",
                        text: "Сталинский",
                        value: "сталинский"
                    },
                    {
                        type: "option",
                        text: "Старый фонд",
                        value: "старый фонд"
                    },
                    {
                        type: "option",
                        text: "Хрущевка",
                        value: "хрущевка"
                    }
                ],
                selected: stock,
                visibility: [
                    "квартира",
                    "комната"
                ].includes(category),
                multiple: true,
                onChange: function(v) {
                    setStock(v);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                title: "Тип участка",
                checkboxes: [
                    {
                        text: "ИЖС",
                        value: "ижс"
                    },
                    {
                        text: "Садовый",
                        value: "садовый"
                    },
                    {
                        text: "Фермерский",
                        value: "фермерский"
                    }
                ],
                selected: lotType,
                visibility: [
                    "дом",
                    "участок"
                ].includes(category),
                onChange: function(v) {
                    setLotType(v);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                title: "Тип дома",
                options: [
                    {
                        type: "option",
                        text: "Доля",
                        value: "доля"
                    },
                    {
                        type: "option",
                        text: "Дуплекс",
                        value: "дуплекс"
                    },
                    {
                        type: "option",
                        text: "Отдельный дом",
                        value: "отдельный дом"
                    },
                    {
                        type: "option",
                        text: "Таунхаус",
                        value: "таунхаус"
                    },
                    {
                        type: "option",
                        text: "Часть дома",
                        value: "часть дома"
                    }
                ],
                selected: subCategory,
                visibility: [
                    "дом"
                ].includes(category),
                multiple: true,
                onChange: function(v) {
                    setSubCategory(v);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                title: "Тип входа",
                checkboxes: [
                    {
                        text: "Общий",
                        value: "общий"
                    },
                    {
                        text: "Отдельный",
                        value: "отдельный"
                    }
                ],
                selected: entrance,
                visibility: [
                    "коммерция"
                ].includes(category),
                single: true,
                onChange: function(v) {
                    setEntrance(v[0]);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                title: "Тип здания",
                options: [
                    {
                        type: "option",
                        text: "Бизнес-центр",
                        value: "бизнес-центр"
                    },
                    {
                        type: "option",
                        text: "Встроенное помещение",
                        value: "встроенное помещение"
                    },
                    {
                        type: "option",
                        text: "Отдельно стоящее здание",
                        value: "отдельно стоящее здание"
                    },
                    {
                        type: "option",
                        text: "Складской комплекс",
                        value: "складской комплекс"
                    },
                    {
                        type: "option",
                        text: "Торговый центр",
                        value: "Торговый центр"
                    }
                ],
                selected: commercialBuildingType,
                visibility: [
                    "коммерция"
                ].includes(category),
                multiple: true,
                onChange: function(v) {
                    setCommercialBuildingType(v);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (_styles_modules_objects_ObjectsFilterMobile_module_scss__WEBPACK_IMPORTED_MODULE_20___default().actions),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        color: "red",
                        fullWidth: true,
                        style: {
                            marginRight: 8
                        },
                        visibility: isAnyFilters(objectsState.filter),
                        onClick: handleResetClick,
                        children: "Очистить"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        color: "green",
                        fullWidth: true,
                        onClick: handleSearchClick,
                        loading: isLoading,
                        children: foundCount > 0 ? "Показать ".concat(foundCount, " ").concat((0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .declOfNum */ .Ak)(foundCount, [
                            "объект",
                            "объекта",
                            "объектов"
                        ])) : "Найти"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ObjectsFilterMobile);


/***/ }),

/***/ 9766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useIsMount; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useIsMount = function() {
    var isMountRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        isMountRef.current = false;
    }, []);
    return isMountRef.current;
};


/***/ }),

/***/ 1385:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cb":"Checkbox_cb__zNEBc","inline":"Checkbox_inline__CYSFn","cbTitle":"Checkbox_cbTitle__452ih","cbContent":"Checkbox_cbContent__KmkMt","cbChekbox":"Checkbox_cbChekbox__d52mx","disabled":"Checkbox_disabled__vYV7z","active":"Checkbox_active__c7_cW"};

/***/ }),

/***/ 4914:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"rd":"Radio_rd__0BfzT","inline":"Radio_inline___zsgd","rdTitle":"Radio_rdTitle__btW0q","rdContent":"Radio_rdContent__fCwBL","rdRadio":"Radio_rdRadio__IL3oA","disabled":"Radio_disabled___WB5e","active":"Radio_active__OTBHA"};

/***/ }),

/***/ 7865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skelet":"Skelet_skelet__Z3L3p","wheeeee":"Skelet_wheeeee__aGXk5","invert":"Skelet_invert__PLaK3"};

/***/ }),

/***/ 9292:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"splitter":"ObjectsFilterMobile_splitter__6B1Qw","actions":"ObjectsFilterMobile_actions__6bXHH"};

/***/ })

}]);